import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-weather-analysis',
  templateUrl: './weather-analysis.component.html',
  styleUrls: ['./weather-analysis.component.css']
})
export class WeatherAnalysisComponent { }